module.exports = __webpack_public_path__ + "img/HeungMingWong.25b798bc.png";